import { gql } from "@apollo/client";

export const QUERY_CARRIER_FUNDING_REQUEST_BY_ME = gql`
  query MyQuery(
    $status: String
    $orderBy: [String]
    $first: Int
    $last: Int
    $before: String
    $after: String
    $userLoadNumber: String
    $debtor: String
    $loadOrInvoiceOrDebtorOrStatus: String
    $assignedLoads: Boolean
  ) {
    fundingRequestsByMe(
      status: $status
      orderBy: $orderBy
      first: $first
      last: $last
      before: $before
      after: $after
      userLoadNumber: $userLoadNumber
      debtor: $debtor
      loadOrInvoiceOrDebtorOrStatus: $loadOrInvoiceOrDebtorOrStatus
      assignedLoads: $assignedLoads
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
      data {
        created
        modified
        id
        amount
        unpaidPurchaseAmount
        billToAddress
        billToCompanyEmail
        billToCompanyPhone
        firstOriginLocation
        finalDestinationLocation
        loadLength
        loadTrailerType
        fundedAt
        userReferenceNumber
        userNotes
        invoiceNumber
        discountRate
        displayDiscountRate
        fuelAdvanceRate
        fuelAdvanceFee
        fuelAdvanceAmount
        invoiceNotes
        carrierInvoiceNotes
        debtorInvoiceNotes
        invoiceSent
        invoiceSentCount
        lastInvoiceSentTime
        invoiceTimeline
        invoiceSequenceNumber
        selfFinanceRequested
        contractType
        contractVersion
        source
        status
        statusNote
        userLoadNumber
        purchaseOrderNumber
        factored
        nonFactoredType
        chargeNonFactoredFee
        MinimumFee
        paymentMethod
        fuelAdvancePaymentMethod
        amountFunded
        factoringDebtorRelation {
          id
          noaSent
          noaPlaced
          noaActive
          noaRequested
          creditApproved
        }
        debtor {
          created
          modified
          id
          email
          noaContactEmail
          paymentStatusEmail
          name
          companyName
          address
          phoneNumber
          faxNumber
          mc
          dot
          taxId
          avgpay
          creditApproved
          creditApprovedNote
          creditLimit
          originalsRequired
          dtpAllowance
          discountRate
          dunsNumber
        }
        needsAdminReview
        paymentStatus
        paymentProfilePaymentMethod
        paymentProfileDiscountRate
        paymentProfileFundedAt
        paymentProfileFundedAmount
        paymentProfileAmount
        factoringAmount
        factoringFeeSplitRate
        fuelAdvanceFeeSplitRate
        reserveHoldbackRate
        carrierProNumber
        reserveHoldback
        selectedFeeSplit
        passDebtorRateToCarrier
        applyReserveHoldback
        payoutDays
        invoiceDate
        frType
        clientInvoiceNumber
        factoring {
          timePosted
          modfied
          id
          companyProfile
          ownerProfile
          factoringApproved
          discountRate
        }
      }
    }
  }
`;
